import styled from "styled-components";

export const TabRoot = styled.div`
    cursor: pointer;
    flex-shrink: 0;
    align-items: center;
`;

export const TabIcon = styled.span`
    width: 18px;
    margin-right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
